<template>
  <div class="topic-type time-topic">
    <div class="topic-container">
      <topic-info :info="info" />
      <div class="operation">
        <div class="positive-timing" v-if="info.tim_type * 1 === 1 && info.p_list && info.p_list.length > 0">
          <div class="tag-list">
            <p>项目</p>
            <ul>
              <li v-for="(item, index) in info.p_list" :key="index" :class="{ active: selectedInfo.index === index }" @click="handleSelect(item, index)">
                {{ item }}
              </li>
            </ul>
          </div>
          <!-- 自定义输入 -->
          <div class="input-container">
            <van-field v-model.trim="customInput" maxlength="8" placeholder="请输入项目" />
            <van-button @click="addCustomProject">添加</van-button>
          </div>
        </div>
        <div class="record-container" :class="{ countdown: info.tim_type * 1 === 2 }">
          <div class="left">
            <div class="record-list">
              <div class="record-item" v-for="(item, index) in answerRecord">
                <div class="record-item-name">{{ info.tim_type * 1 === 1 && info.p_list && info.p_list.length > 0 ? item.name : `第${numberToChinese(index+1)}次` }}</div>
                <div class="record-item-time">
                  <span>{{ item.formattedTime }}</span>
                  <div class="delete" @click="deleteRecord(item,index)">
                    <van-icon name="cross" />
                  </div>
                </div>
              </div>
            </div>
            <div class="record-statistics">
              <p v-if="info.tim_type * 1 === 1">当前有效时间：{{ effectiveTime.formattedTime }}</p>
              <template v-else>
                <p>有效次数：{{ answerRecord.length }}次</p>
                <p>倒计时：{{ formatTime(recordTime) }}</p>
              </template>
            </div>
          </div>
          <div class="right">
            <template v-if="info.tim_type * 1 === 1">
              <div class="time">{{ formatTime(recordTime) }}</div>
              <div class="icon">
                <img src="@/assets/img/btn-play.png" alt="" v-if="!inTiming" @click="timingStart">
                <img src="@/assets/img/btn-pause.png" alt="" v-else @click="timingEnd">
              </div>
              <div class="item">{{ timingItem.name }}</div>
            </template>
            <template v-if="info.tim_type * 1 === 2">
              <div class="record" v-if="!inTiming">点击下方按钮<br>开始倒计时</div>
              <div class="record" v-else>点击下方按钮<br>记录</div>
              <div class="icon">
                <img src="@/assets/img/btn-play.png" alt="" v-if="!inTiming" @click="timingStart">
                <img src="@/assets/img/btn-record.png" alt="" v-else @click="timingEnd">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 指令 -->
    <div class="instruction-container" v-if="info.edict">
      <div class="content" :class="{open: instructionShow}">
        <p v-show="instructionShow">{{ info.edict }}</p>
        <van-icon name="arrow-left" v-show="instructionShow" @click="instructionShow = false" />
      </div>
      <div class="btn" @click="instructionShow = true">
        <img src="@/assets/img/instruction.png" alt="">
      </div>
    </div>
    <tip-modal v-if="tipShow" :show.sync="tipShow" :options="tipOptions" @confirm="tipConfirm" @cancel="tipCancel"></tip-modal>
  </div>
</template>

<script>
import TopicInfo from "../TopicInfo";
import TipModal from "../TipModal";
export default {
  name: "TimeTopic",
  components: {
    TopicInfo,
    TipModal
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    isHand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      score: 0,
      instructionShow: false,
      answerRecord: [],
      selectedInfo: {
        index: -1,
        name: ''
      },
      customInput: '',
      customItem: '',
      recordTime: 0,
      inTiming: false,
      timer: null,
      tipShow: false,
      tipOptions: {},
    }
  },
  computed: {
    effectiveTime() {
      let item = this.info.tim_type * 1 === 1 && this.answerRecord.length > 0 ? this.answerRecord.reduce((prev, curr) => {
        return prev.time > curr.time ? prev : curr;
      }) : {};
      return item;
    },
    timingItem() {
      let obj = { type: '', name: '' }
      if (this.selectedInfo.index >= 0 && this.info.p_list && this.selectedInfo.index < this.info.p_list.length) {
        obj.type = 1;
        obj.name = this.selectedInfo.name;
      } else if (this.customItem) {
        obj.type = 0;
        obj.name = this.customItem;
      }
      return obj;
    }
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    }
  },
  created() {
    this.info = this.$route.query.topic_sort * 1 > 0 ? this.topicInfo.topic_info : this.topicInfo;
    if (this.info.tim_type * 1 === 2) {
      this.recordTime = this.info.duration * 1;
    }
    // 初始化答题记录
    if (this.topicInfo.son_toprecrd) {
      this.answerRecord = this.topicInfo.son_toprecrd.map(record => {
        let obj = {
          time: record.time,
          formattedTime: this.formatTime(record.time),
        }
        if (this.info.tim_type * 1 === 1) {
          obj.type = record.type
          obj.name = record.name
        }
        return obj
      });
    }
  },
  destroyed() {
    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    handleSelect(item, index) {
      if (this.inTiming) {
        this.timingEnd()
      }
      this.$set(this.selectedInfo, 'index', index);
      this.$set(this.selectedInfo, 'name', item);
      this.customInput = '';
      this.customItem = '';
    },
    // 添加自定义项目
    async addCustomProject() {
      if (!this.customInput) {
        return this.$vantnotify('添加项目名称不能为空');
      };
      if (this.info.p_list.some(item => item === this.customInput)) {
        return this.$vantnotify('该项目已存在');
      };
      if (this.inTiming) {
        this.timingEnd()
      }
      this.customItem = this.customInput;
      this.customInput = '';
      this.$set(this.selectedInfo, 'index', -1);
      this.$set(this.selectedInfo, 'name', '');
    },
    timingStart() {
      if (this.info.tim_type * 1 === 1 && (this.info.p_list && this.info.p_list.length > 0 && (!this.timingItem.name || this.timingItem.name === ''))) {
        return this.$vantnotify('请选择项目');
      }
      if (this.info.tim_type * 1 === 2 && this.answerRecord.length > 0) {
        this.tipOptions = {
          type: 1,
          message: "重新计时后将清空已记录数据，是否确认？"
        };
        return this.tipShow = true;
      }
      this.inTiming = true;
      this.timer = setInterval(() => {
        if (this.info.tim_type * 1 === 1) {
          this.recordTime += 1;
        }
        if (this.info.tim_type * 1 === 2) {
          this.recordTime -= 1;
          if (this.recordTime <= 0) {
            clearInterval(this.timer);
            this.inTiming = false;
            this.recordTime = this.info.duration * 1;
          }
        }
      }, 1000);
    },
    timingEnd() {
      let obj = {
        time: this.recordTime,
        formattedTime: this.formatTime(this.recordTime)
      }
      if (this.info.tim_type * 1 === 1) {
        obj.type = this.timingItem.type
        obj.name = this.timingItem.name
      }
      this.answerRecord.push(obj)
      if (this.info.tim_type * 1 === 1) {
        this.recordTime = 0
        clearInterval(this.timer);
        this.inTiming = false;
      }
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.$nextTick(() => {
        this.calculateScore();
      })
    },
    formatTime(seconds) {
      const hour = Math.floor(seconds / 3600);
      const minute = Math.floor((seconds % 3600) / 60);
      const second = Math.floor(seconds % 60);
      if (this.info.tim_type * 1 === 1) {
        return hour > 0 ? `${hour}时${minute}分${second}秒` : `${minute}分${second}秒`;
      }
      if (this.info.tim_type * 1 === 2) {
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
      }
    },
    numberToChinese(num) {
      if (num > 100 || num < 1) return num;
      const units = ['', '十', '百'];
      const numbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
      if (num <= 10) return numbers[num];
      if (num > 10 && num < 20) return `十${numbers[num % 10] === '零' ? '' : numbers[num % 10]}`;
      const numStr = num.toString();
      let result = '';
      for (let i = 0; i < numStr.length; i++) {
        const digit = parseInt(numStr[i]);
        if (digit === 0) {
          if (result.slice(-1) !== '零' && i !== numStr.length - 1) {
            result += '零';
          }
        } else {
          result += numbers[digit] + units[numStr.length - 1 - i];
        }
      }
      return result.replace(/零+$/, '');
    },
    deleteRecord(item, index) {
      this.answerRecord.splice(index, 1)
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.$nextTick(() => {
        this.calculateScore();
      })
    },
    // 计算分数
    calculateScore() {
      if (this.isHand) return;
      if (this.answerRecord.length === 0) {
        this.score = '';
      } else {
        let effectiveValue = this.info.tim_type * 1 === 1 ? this.effectiveTime.time * 1 : this.answerRecord.length
        if (effectiveValue >= this.info.full_mark * 1) {
          this.score = 1;
        } else if (effectiveValue >= this.info.half_mark * 1) {
          this.score = 0.5;
        } else {
          this.score = 0;
        }
      }
      this.$emit('input', this.score);
    },
    async tipConfirm() {
      if (this.tipOptions.type === 1) {
        this.$set(this, 'answerRecord', []);
        this.$nextTick(() => {
          this.calculateScore();
          this.timingStart()
        })
      }
      this.tipShow = false;
    },
    tipCancel() {
      this.tipShow = false;
    }
  },
}
</script>

<style lang="less" scoped>
.operation {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0.2rem 0.15rem;
  overflow-y: scroll;
  .positive-timing {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .tag-list {
    display: flex;
    line-height: 0.34rem;
    margin-right: 0.1rem;
    p {
      font-size: 0.14rem;
      font-weight: bold;
      color: #630200;
      line-height: 0.36rem;
    }
    ul {
      flex: 1;
      li {
        display: inline-block;
        height: 0.34rem;
        font-size: 0.14rem;
        color: #630200;
        padding: 0 0.1rem;
        background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
        box-shadow: inset 0 0 0.06rem 1px #ffaa71;
        border-radius: 0.08rem;
        cursor: pointer;
        margin-left: 0.1rem;
        &.active {
          color: #5a3600;
          background: #ffe56f;
          box-shadow: inset 0 0.03rem 0.06rem 1px #ffcd00;
        }
      }
    }
  }
  .input-container {
    height: 0.34rem;
    background: #ffffff;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: fit-content;
    .van-cell {
      width: 1.5rem;
      height: 100%;
      padding: 0 0.1rem;
      font-size: 0.14rem;
      border-radius: 0.04rem 0 0 0.04rem;
      line-height: 0.32rem;
      border: 1px solid #ff7e2b;
      &::after {
        display: none;
      }
    }
    .van-button {
      height: 100%;
      border: none;
      border-radius: 0 0.04rem 0.04rem 0;
      background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
      font-size: 0.14rem;
      color: #fff;
    }
  }
  .record-container {
    height: 40vh;
    margin-top: 0.16rem;
    display: flex;
    background: #fff;
    box-shadow: 0 0 0.2rem 1px rgba(255, 183, 142, 0.57);
    border-radius: 0.2rem;
    max-height: 100%;
    .left {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0.15rem 0.22rem;
      .record-list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: scroll;
        .record-item {
          display: flex;
          align-items: center;
          height: 0.3rem;
          background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
          box-shadow: inset 0 0 0.06rem 1px #ffaa71;
          border-radius: 0.1rem;
          font-size: 0.12rem;
          color: #5a3600;
          line-height: 0.3rem;
          margin: 0 0.16rem 0.13rem 0;
        }
        .record-item-name {
          padding: 0 0.14rem;
        }
        .record-item-time {
          height: 100%;
          background: #ffffff;
          box-shadow: inset 0 0 0.06rem 1px #ffaa71;
          padding: 0 0.14rem;
          border-radius: 0.1rem;
          display: flex;
          align-items: center;
        }
        .delete {
          width: 0.16rem;
          height: 0.16rem;
          background: #ffeeee;
          border-radius: 50%;
          margin-left: 0.1rem;
          font-size: 0.12rem;
          color: #ff7170;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .record-statistics {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        font-size: 0.15rem;
        color: #630200;
        margin-top: 0.05rem;
      }
    }
    .right {
      width: 2.2rem;
      background: linear-gradient(
        135deg,
        #ffe0cf 0%,
        #fffde1 46%,
        #ffd8c5 100%
      );
      border-radius: 0 0.2rem 0.2rem 0;
      border: 1px solid #ffc8a9;
      border-left-width: 0.04rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: #630200;
      text-align: center;
      .time {
        font-size: 0.18rem;
      }
      .record {
        font-size: 0.16rem;
        line-height: 1.6;
      }
      .icon {
        width: 0.6rem;
        height: 0.6rem;
        font-size: 0;
        margin: 0.1rem 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item {
        font-size: 0.16rem;
      }
    }
    &.countdown {
      margin-top: 0;
      height: 50vh;
    }
  }
}
.instruction-container {
  min-width: 0.46rem;
  height: 0.46rem;
  position: fixed;
  bottom: 1rem;
  left: 0;
  border-radius: 0.23rem;
  .content {
    width: 0;
    height: 0.43rem;
    background: linear-gradient(205deg, #ffecd6 0%, #ffda95 100%);
    border-radius: 0 0.2rem 0.2rem 0;
    border: 1px solid #ffc767;
    font-size: 0.12rem;
    color: #540200;
    line-height: 0.14rem;
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    transition: all 0.1s ease;
    box-sizing: border-box;
    p {
      // 限制最多显示两行
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
    }
    .van-icon {
      color: #f59f0c;
      font-size: 0.14rem;
      margin-left: 0.05rem;
    }
    &.open {
      width: max-content;
      max-width: 3rem;
      padding: 0 0.15rem 0 0.3rem;
    }
  }
  .btn {
    width: 0.46rem;
    height: 0.46rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>